<template>
  <transition name="fade" v-if="currentStep == 5">
    <div :class="panelPropostaColor">
      <div
        class="panel-heading"
        @click="show = !show"
      >
        5 - RESULTADO PROPOSTA
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              show
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="show" class="panel-body" :style="panelPropostaBackColor">
        <div class="row">
          <div class="col-xs-6">
            <span class="font-weight-bold">Data da Solicitação: </span>
            <span>{{ this.resultadoProposta.CreatedAt | datahorabr }}</span>
          </div>
          <div class="col-xs-6">
            <span class="font-weight-bold">Situação: </span>
            <span>{{
              this.resultadoProposta.Success ? "Aguardando finalização do pedido" : "Negado"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SolAgoraStep5",
  props: {
    currentStep: { type: Number, default: 0 },
    resultadoProposta: { type: Object, default: null },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    panelPropostaColor: function () {
      return this.resultadoProposta.Success
        ? "panel panel-success"
        : "panel panel-danger";
    },
    panelPropostaBackColor: function () {
      return this.resultadoProposta.Success
        ? "background:#f3fffa;"
        : "background:#fff3f3;";
    },
  },
};
</script>